import { Component } from '@angular/core';
import {ParallaxSectionComponent} from '../parallax-section/parallax-section.component';

@Component({
  selector: 'app-pro-contra-prallax-section',
  standalone: true,
    imports: [
        ParallaxSectionComponent
    ],
  templateUrl: './pro-contra-prallax-section.component.html',
  styleUrl: './pro-contra-prallax-section.component.scss'
})
export class ProContraPrallaxSectionComponent {

}
